export default "__VITE_ASSET__L3wQRa7C__"